<div class="taxonomy-dialog-container">
	<div class="d-flex justify-content-between align-items-center">
		<span class="title" mat-dialog-title>{{ 'CLIPS.TAXONOMY.EDIT_TITLE' | translate }}</span>
		<button mat-icon-button (click)="closeDialog()" class="d-flex justify-content-center align-items-center me-4">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="m-0 p-3">
		<div class="row">
			<mat-form-field appearance="outline">
				<mat-label>{{ 'CLIPS.TAXONOMY.SOURCE_TYPE' | translate }}</mat-label>
				<mat-select [(ngModel)]="sourceType">
					<mat-option value="">{{ 'CLIPS.TAXONOMY.NONE' | translate }}</mat-option>
					@for (option of sourceTypes; track option) {
					<mat-option [value]="option">{{ translateSourceTypeLabel(option) }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>

		<mat-divider class="my-2"></mat-divider>

		<div class="taxonomy-group-label d-flex align-items-center justify-content-between">
			<span>{{ 'CLIPS.TAXONOMY.INDUSTRY_TOPICS' | translate }}</span>
			<span class="taxonomy-hint">{{ 'CLIPS.TAXONOMY.MAX_TWO_HINT' | translate }}</span>
		</div>
		<div class="taxonomy-options">
			@for (topic of industryTopics; track topic) {
			<mat-checkbox
				color="primary"
				[checked]="selectedIndustryTopics.includes(topic)"
				[disabled]="!selectedIndustryTopics.includes(topic) && selectedIndustryTopics.length >= 2"
				(change)="toggleIndustryTopic(topic, $event.checked)">
				{{ translateTopicLabel(topic) }}
			</mat-checkbox>
			}
		</div>

		<mat-divider class="my-2"></mat-divider>

		<div class="taxonomy-group-label d-flex align-items-center justify-content-between">
			<span>{{ 'CLIPS.TAXONOMY.CORPORATE_TOPICS' | translate }}</span>
			<span class="taxonomy-hint">{{ 'CLIPS.TAXONOMY.MAX_TWO_HINT' | translate }}</span>
		</div>
		<div class="taxonomy-options">
			@for (topic of corporateTopics; track topic) {
			<mat-checkbox
				color="primary"
				[checked]="selectedCorporateTopics.includes(topic)"
				[disabled]="!selectedCorporateTopics.includes(topic) && selectedCorporateTopics.length >= 2"
				(change)="toggleCorporateTopic(topic, $event.checked)">
				{{ translateTopicLabel(topic) }}
			</mat-checkbox>
			}
		</div>
	</mat-dialog-content>

	<mat-dialog-actions [align]="'end'" class="px-3">
		<mat-divider class="w-100 my-2"></mat-divider>
		<div class="d-flex pt-0">
			<button mat-flat-button color="primary" (click)="save()" [disabled]="saving">
				<div class="d-flex">
					@if (saving) {
					<mat-spinner diameter="15" class="me-1"></mat-spinner>
					}
					<span>{{ 'BUTTON.SAVE' | translate }}</span>
				</div>
			</button>
			<button mat-flat-button (click)="closeDialog()" [disabled]="saving">
				{{ 'BUTTON.CANCEL' | translate }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
